import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
    (res) => res,
    (err) => {
        const detail = err.response?.data?.detail;
        if (err.response?.status === 403 && typeof detail === "string" && detail.includes("pasifleştirildi")) {
            toast.error(detail, { id: "account-passive", duration: 8000 });
        }
        return Promise.reject(err);
    }
);

export const fmtTL = (n) =>
    new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 2 }).format(n ?? 0);

export const fmtDate = (iso) =>
    iso ? new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const ORDER_STATUS = {
    pending: { label: "Onay Bekliyor", cls: "bg-amber-100 text-amber-800 border-amber-200" },
    confirmed: { label: "Onaylandı", cls: "bg-blue-100 text-blue-800 border-blue-200" },
    preparing: { label: "Hazırlanıyor", cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
    shipped: { label: "Kargoda", cls: "bg-purple-100 text-purple-800 border-purple-200" },
    delivered: { label: "Teslim Edildi", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
    cancelled: { label: "İptal", cls: "bg-red-100 text-red-700 border-red-200" },
    returned: { label: "İade Edildi", cls: "bg-orange-100 text-orange-800 border-orange-200" },
};

export const RFQ_STATUS = {
    open: { label: "Açık", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
    quoted: { label: "Teklifler Geldi", cls: "bg-blue-100 text-blue-800 border-blue-200" },
    accepted: { label: "Tamamlandı", cls: "bg-stone-200 text-stone-700 border-stone-300" },
    closed: { label: "Kapandı", cls: "bg-stone-200 text-stone-600 border-stone-300" },
};

export const QUOTE_STATUS = {
    pending: { label: "Değerlendiriliyor", cls: "bg-amber-100 text-amber-800 border-amber-200" },
    accepted: { label: "Kabul Edildi", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
    rejected: { label: "Reddedildi", cls: "bg-red-100 text-red-700 border-red-200" },
};

export const SHIPMENT_STATUS = {
    pending: { label: "Hazırlanıyor", cls: "bg-amber-100 text-amber-800 border-amber-200" },
    shipped: { label: "Yolda", cls: "bg-purple-100 text-purple-800 border-purple-200" },
    delivered: { label: "Teslim Edildi", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
    cancelled: { label: "İptal", cls: "bg-red-100 text-red-700 border-red-200" },
};

export const INVOICE_STATUS = {
    issued: { label: "Ödeme Bekliyor", cls: "bg-amber-100 text-amber-800 border-amber-200" },
    paid: { label: "Ödendi", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
    cancelled: { label: "İptal", cls: "bg-red-100 text-red-700 border-red-200" },
    returned: { label: "İade", cls: "bg-orange-100 text-orange-800 border-orange-200" },
};

export const ROLE_TR = { buyer: "Alıcı", supplier: "Tedarikçi", admin: "Admin" };
export const QUALITY_OPTIONS = ["Premium", "1. Kalite", "2. Kalite", "Standart"];

export const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/panel";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const speakText = async (text, voiceId) => {
    const resp = await fetch(`${API}/tts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ text, voice_id: voiceId }),
    });
    if (!resp.ok) {
        const j = await resp.json().catch(() => ({}));
        throw new Error(j.detail || "Ses üretilemedi");
    }
    const blob = await resp.blob();
    const url = URL.createObjectURL(blob);
    const audio = new Audio(url);
    audio.onended = () => URL.revokeObjectURL(url);
    await audio.play();
    return audio;
};
